// Brief 85 §2 — JurisdictionModal, moved out of App.tsx's renderModals switch.
//
// MOVED, NOT REWRITTEN. The body below is byte-identical to the `case "ju":`
// clause it left —
//   sha256 273f63940b3d1f8929bc880bd4fd4ed37a7270f806b212043e30d45f79f61697
// — including its original indentation, which is why it sits deeper than this
// file's own wrapper. Only the imports, the Props type, the signature and the
// `return (` / `);` are new.
// Do not reformat: the indentation IS the proof.
//
// Props are the UNION of the names the body actually read in App scope, taken
// from a TypeScript-checker walk rather than chosen — a passed-but-unread prop
// would mean the union rule absorbed something it should have refused.
// The vocabulary props are typed by inference off makeModalFields' return, so
// this file adds nothing to the `any` ratchet.

import { ModalLayout } from "../SharedUI";
import { SK } from "../../utils";

import type { makeModalFields } from "../modalFields";

type Vocab = ReturnType<typeof makeModalFields>;
type ModalForm = { id?: string | null };

type Props = {
  F: Vocab["F"];
  _mt: Vocab["_mt"];
  cm: () => void;
  form: ModalForm;
  jurisdictions: readonly unknown[];
  saveEntity: (k: string, rows: readonly unknown[], set: (v: readonly unknown[]) => void, f: unknown) => void;
  setJurisdictions: (v: readonly unknown[]) => void;
};

export default function JurisdictionModal({
  F,
  _mt,
  cm,
  form,
  jurisdictions,
  saveEntity,
  setJurisdictions,
}: Props) {
  return (
          <ModalLayout
            title={form.id ? _mt("Edit Jurisdiction") : _mt("New Jurisdiction")}
            onClose={cm}
            onSave={() => saveEntity(SK.ju, jurisdictions, setJurisdictions, form)}
          >
              <>
                {F("Court *", "name", "", 1)}
                {F("Address", "address")}
                <div className="field-row">
                  {F("Postal Code", "postalCode")}
                  {F("City", "city")}
                </div>
                <div className="field-row">
                  {F("Tel", "tel", "e.g. 02 508 62 63")}
                  {F("Email", "email", "")}
                </div>
              </>
          </ModalLayout>
  );
}
